import {API_URLS} from '@px/const/urls';
import {http} from '@px/helper/http';

export const abtestApi = {
  abtest(query) {
    return http.get(API_URLS.ABTEST, {
      query,
      formatter(data) {
        data.experiment = !!data.experiment;
        return data;
      },
    });
  },
  commonAbtest(query) {
    return http.get(API_URLS.ABTEST, {
      query,
    });
  },
};
